import { useState } from "react";

const LINK_TIA  = "https://auth.flowiq.live/functions/v1/inbox-access-link?token=dc27be225d4a89041f8acff522d0231f8582eee9f266fc009c65095d692df7af";
const LINK_MATT = "https://auth.flowiq.live/functions/v1/inbox-access-link?token=a8ef4547956298f6136059a25ddcebe2740292302b74870d588c2c7b34d6acc5";
const LINK_DEFAULT = LINK_TIA;

const CASES = [
  { id: "00021802", contact: "Matt Cronson",        origin: "Email",        subject: "Missing parts – please deliver to my home",                           status: "New",                 priority: "Medium", opened: "20/02/2076, 08:47", owner: "Deliveries", link: LINK_MATT },
  { id: "00021801", contact: "Sabrina Martins",     origin: "Email",        subject: "Order #3300751886 Damaged Items",                                      status: "In Progress",         priority: "Medium", opened: "20/02/2076, 08:30", owner: "inuit",      link: LINK_DEFAULT },
  { id: "00021808", contact: "Tia Gekis",           origin: "Email",        subject: "Request for Exchange of Online Purchase, Order number: 2...",           status: "Waiting for Customer",priority: "Medium", opened: "20/02/2076, 08:21", owner: "inuit",      link: LINK_TIA },
  { id: "00021809", contact: "Khalil Gul-e-ul Fnu Hermanma", origin: "Email", subject: "Decofurn x Khalil mini-liana Collaboration Opportunity",             status: "Waiting for Customer",priority: "Medium", opened: "20/02/2076, 08:03", owner: "inuit",      link: LINK_DEFAULT },
  { id: "00021807", contact: "Dania Singaan",       origin: "Email",        subject: "Order number #00021807 – incorrect item",                              status: "Waiting for Customer",priority: "Medium", opened: "20/02/2076, 07:54", owner: "Malque",     link: LINK_DEFAULT },
  { id: "00021806", contact: "Nobunada Phaxu",      origin: "Email",        subject: "DECOFURN",                                                             status: "Waiting for Customer",priority: "Medium", opened: "20/02/2076, 07:24", owner: "Malque",     link: LINK_DEFAULT },
  { id: "00021804", contact: "",                    origin: "AI Assistant",  subject: "Missing R755 discount – Order Reference: 00G306028",                  status: "Waiting for Customer",priority: "Medium", opened: "20/02/2076, 07:08", owner: "inuit",      link: LINK_DEFAULT },
  { id: "00021803", contact: "",                    origin: "Email",        subject: "Bed Base",                                                             status: "In Progress",         priority: "Medium", opened: "20/02/2076, 06:57", owner: "inuit",      link: LINK_DEFAULT },
  { id: "00021803", contact: "",                    origin: "Email",        subject: "I'm Damaged Bar Stool",                                                status: "In Progress",         priority: "Medium", opened: "20/02/2076, 04:14", owner: "inuit",      link: LINK_DEFAULT },
  { id: "00021807", contact: "Neethu Dalia",        origin: "Email",        subject: "Cancellation of Order",                                                status: "In Progress",         priority: "Medium", opened: "20/02/2076, 04:04", owner: "inuit",      link: LINK_DEFAULT },
  { id: "00021807", contact: "Ahmad Faisal",        origin: "Email",        subject: "Warranty claim OR #00023491",                                          status: "In Progress",         priority: "Medium", opened: "20/02/2076, 01:28", owner: "inuit",      link: LINK_DEFAULT },
  { id: "00021816", contact: "",                    origin: "AI Assistant",  subject: "Colour change request for order #00030884",                            status: "In Progress",         priority: "Medium", opened: "20/02/2076, 00:08", owner: "klaus",      link: LINK_DEFAULT },
  { id: "00021817", contact: "Tilde Dalan",         origin: "Email",        subject: "T/R / condition Query",                                                status: "Waiting for Customer",priority: "Medium", opened: "20/02/2076, 18:19", owner: "inuit",      link: LINK_DEFAULT },
  { id: "00021815", contact: "Adile Lariga",        origin: "Email",        subject: "Cracked TV units",                                                     status: "In Progress",         priority: "Medium", opened: "20/02/2076, 18:08", owner: "inuit",      link: LINK_DEFAULT },
  { id: "00021811", contact: "Thulz Mabathloa",     origin: "Email",        subject: "Return order, Order #00030800",                                        status: "In Progress",         priority: "Medium", opened: "20/02/2076, 18:07", owner: "inuit",      link: LINK_DEFAULT },
];

const STATUS_COLORS: Record<string, string> = {
  "New": "text-blue-600",
  "In Progress": "text-yellow-600",
  "Waiting for Customer": "text-orange-500",
  "Closed": "text-green-600",
};

const TopNav = () => (
  <div className="bg-[#0176d3] h-11 flex items-center px-3 gap-3 shrink-0">
    <div className="w-7 h-7 bg-white rounded-full opacity-80 flex items-center justify-center">
      <div className="w-4 h-4 bg-[#0176d3] rounded-full" />
    </div>
    <span className="text-white font-semibold text-sm">Service Console</span>
    <div className="ml-3 flex gap-0.5 text-xs text-white/80">
      {["Home", "Cases", "Contacts", "Accounts", "Reports"].map((t) => (
        <div key={t} className="px-3 py-1 hover:bg-white/10 rounded cursor-pointer">{t}</div>
      ))}
    </div>
    <div className="ml-auto bg-yellow-400 text-gray-900 text-xs font-bold px-3 py-1 rounded">
      ⚠ Pretend this is Salesforce
    </div>
  </div>
);

type Case = typeof CASES[0];

const ListView = ({ onSelect }: { onSelect: (c: Case) => void }) => (
  <div className="flex flex-col h-full">
    <TopNav />
    {/* Tab bar */}
    <div className="bg-[#f3f3f3] border-b border-gray-300 flex items-center px-3 text-xs">
      <div className="px-4 py-2 bg-white border-t-2 border-[#0176d3] text-[#0176d3] font-semibold border-x border-gray-300 cursor-pointer">
        Cases
      </div>
      <div className="px-4 py-2 text-gray-500 cursor-pointer hover:bg-white/60">All Open Cases ▾</div>
    </div>
    {/* Toolbar */}
    <div className="bg-white border-b border-gray-200 flex items-center px-4 py-2 gap-2">
      <span className="text-sm font-semibold text-gray-800 mr-2">All Open Cases ▾</span>
      <div className="ml-auto flex gap-2">
        {["New", "Change Owner", "Merge Cases", "Printable View", "Close the Case"].map((btn) => (
          <button key={btn} className="px-3 py-1 text-xs border border-gray-300 rounded text-gray-600 hover:bg-gray-50">
            {btn}
          </button>
        ))}
      </div>
    </div>
    {/* Filter bar */}
    <div className="bg-white border-b border-gray-200 px-4 py-1 text-xs text-gray-400">
      50+ items • Sorted by Date/Time Opened • Filtered by Status • Updated a few seconds ago
    </div>
    {/* Table */}
    <div className="flex-1 overflow-auto bg-white">
      <table className="w-full text-xs border-collapse">
        <thead>
          <tr className="bg-gray-50 border-b border-gray-200 text-gray-500 font-semibold uppercase tracking-wide">
            <th className="px-3 py-2 text-left w-6"></th>
            <th className="px-3 py-2 text-left">Case Number</th>
            <th className="px-3 py-2 text-left">Contact Name</th>
            <th className="px-3 py-2 text-left">Case Origin</th>
            <th className="px-3 py-2 text-left">Subject</th>
            <th className="px-3 py-2 text-left">Status</th>
            <th className="px-3 py-2 text-left">Priority</th>
            <th className="px-3 py-2 text-left">Date/Time Opened</th>
            <th className="px-3 py-2 text-left">Case Owner Alias</th>
          </tr>
        </thead>
        <tbody>
          {CASES.map((c, i) => (
            <tr
              key={i}
              className="border-b border-gray-100 hover:bg-blue-50 cursor-pointer"
              onClick={() => onSelect(c)}
            >
              <td className="px-3 py-2 text-gray-300">{i + 20}</td>
              <td className="px-3 py-2 text-[#0176d3] font-medium hover:underline">{c.id}</td>
              <td className="px-3 py-2 text-gray-700">{c.contact}</td>
              <td className="px-3 py-2 text-gray-600">{c.origin}</td>
              <td className="px-3 py-2 text-gray-700 max-w-xs truncate">{c.subject}</td>
              <td className={`px-3 py-2 font-medium ${STATUS_COLORS[c.status] ?? "text-gray-600"}`}>{c.status}</td>
              <td className="px-3 py-2 text-gray-600">{c.priority}</td>
              <td className="px-3 py-2 text-gray-500">{c.opened}</td>
              <td className="px-3 py-2 text-[#0176d3]">{c.owner}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

const DetailView = ({ c, onBack }: { c: Case; onBack: () => void }) => {
  const [activeTab, setActiveTab] = useState("Details");

  return (
    <div className="flex flex-col h-full">
      <TopNav />
      {/* Tab bar */}
      <div className="bg-[#f3f3f3] border-b border-gray-300 flex items-center px-3 text-xs">
        <div
          className="px-4 py-2 text-gray-500 cursor-pointer hover:bg-white/60"
          onClick={onBack}
        >
          Cases
        </div>
        <span className="text-gray-400">›</span>
        <div className="px-4 py-2 bg-white border-t-2 border-[#0176d3] text-[#0176d3] font-semibold border-x border-gray-300 cursor-pointer">
          {c.id} | Case
        </div>
      </div>

      {/* Case header */}
      <div className="bg-white border-b border-gray-200 px-5 pt-3 pb-0">
        <div className="flex items-start gap-3">
          <div className="w-8 h-8 rounded bg-red-500 flex items-center justify-center text-white text-xs font-bold shrink-0 mt-1">C</div>
          <div className="flex-1">
            <div className="text-xs text-gray-400 mb-0.5">
              {c.contact || "AI Assistant"} · {c.contact ? <span className="text-[#0176d3]">Contact Details</span> : null}
            </div>
            <div className="flex items-center gap-6 text-xs text-gray-500 mb-2">
              <span>Case Number: <span className="font-semibold text-gray-800">{c.id}</span></span>
              <span>Case Origin: <span className="font-semibold text-gray-800">{c.origin}</span></span>
              <span>Type: <span className="font-semibold text-gray-800">Complaints</span></span>
            </div>
          </div>
          <div className="flex gap-2 shrink-0">
            {["New", "In Progress", "Waiting for Customer", "Closed"].map((s) => (
              <button
                key={s}
                className={`px-3 py-1.5 text-xs rounded-sm font-medium border transition-colors ${
                  c.status === s
                    ? "bg-[#0176d3] text-white border-[#0176d3]"
                    : "bg-gray-100 text-gray-500 border-gray-200 hover:bg-gray-200"
                }`}
              >
                {s}
              </button>
            ))}
          </div>
        </div>
        {/* Tabs */}
        <div className="flex gap-0 mt-1 -mb-px">
          {["Details", "Feed", "Related"].map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`px-4 py-2 text-sm border-b-2 transition-colors ${
                activeTab === tab
                  ? "border-[#0176d3] text-[#0176d3] font-semibold"
                  : "border-transparent text-gray-500 hover:text-gray-700"
              }`}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>

      {/* Body */}
      <div className="flex flex-1 overflow-hidden">
        {/* Main panel */}
        <div className="flex-1 overflow-auto p-4 flex flex-col gap-4">
          {/* Details fields */}
          <div className="bg-white rounded border border-gray-200 shadow-sm">
            <div className="px-4 py-2 border-b border-gray-200 text-xs font-semibold text-gray-500 uppercase tracking-wide">Case Information</div>
            <div className="p-4 grid grid-cols-2 gap-x-8 gap-y-3 text-sm">
              {[
                ["Case Origin", c.origin],
                ["Priority", c.priority],
                ["Status", c.status],
                ["Case Owner", c.owner],
                ["Case Chat Link", null],
                ["Subject", c.subject],
                ["Contact Name", c.contact || "—"],
                ["Date/Time Opened", c.opened],
                ["Type", "Complaints"],
              ].map(([label, value]) => (
                <div key={label}>
                  <div className="text-xs text-gray-400 mb-0.5">{label}</div>
                  {label === "Case Chat Link" ? (
                    <a
                      href={c.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sm text-[#0176d3] underline hover:text-[#0163b3] transition-colors"
                    >
                      https://example.link
                    </a>
                  ) : (
                    <div className="text-gray-800">{value}</div>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Description */}
          <div className="bg-white rounded border border-gray-200 shadow-sm">
            <div className="px-4 py-2 border-b border-gray-200 text-xs font-semibold text-gray-500 uppercase tracking-wide">Description</div>
            <div className="p-4 text-sm text-gray-600 leading-relaxed">
              {c.subject}. Customer has reached out regarding this issue and is awaiting resolution.
              Please review the case details and follow up accordingly.
            </div>
          </div>

          {/* Actions */}
          <div className="bg-white rounded border border-gray-200 shadow-sm">
            <div className="px-4 py-2 border-b border-gray-200 flex items-center gap-3">
              <span className="text-xs font-semibold text-gray-500 uppercase tracking-wide">Actions</span>
              <span className="bg-yellow-400 text-gray-900 text-xs font-bold px-2 py-0.5 rounded">
                ⚠ Pretend this is Salesforce
              </span>
            </div>
            <div className="p-4 flex gap-3 items-center">
              <button
                onClick={() => window.open(c.link, "_blank", "width=600,height=700,noopener,noreferrer")}
                className="px-4 py-2 bg-[#0176d3] text-white text-sm rounded hover:bg-[#0163b3] transition-colors"
              >
                Click here
              </button>
              <button className="px-4 py-2 border border-gray-300 text-gray-600 text-sm rounded hover:bg-gray-50 transition-colors">
                Close Case
              </button>
            </div>
          </div>
        </div>

        {/* Right sidebar */}
        <div className="w-64 shrink-0 border-l border-gray-200 bg-gray-50 overflow-auto flex flex-col gap-0">
          {[
            { label: "Milestones", count: null },
            { label: "Case Activities", count: 0 },
            { label: "Files", count: 0 },
            { label: "Annoted Files", count: null },
            { label: "Case Comments", count: 0 },
            { label: "Contact Details", count: null },
          ].map(({ label, count }) => (
            <div key={label} className="border-b border-gray-200 bg-white">
              <div className="px-4 py-2 flex items-center justify-between text-xs font-semibold text-gray-600">
                <span>{label}{count !== null ? ` (${count})` : ""}</span>
                <span className="text-gray-300">›</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const Demo = () => {
  const [selected, setSelected] = useState<Case | null>(null);

  return (
    <div className="h-screen flex flex-col font-sans text-sm overflow-hidden">
      {selected
        ? <DetailView c={selected} onBack={() => setSelected(null)} />
        : <ListView onSelect={setSelected} />
      }
    </div>
  );
};

export default Demo;
